/**
 * @yanolja-org/core-ui — widgets/CoreUIDataProvider/context.ts
 *
 * Provider Context 의 생성 + 호스트 노출 hook (`useCoreUIDataContext`).
 *
 * Context default 는 `null` — Provider 없이 컴포넌트가 사용될 때 dumb 모드 폴백 가능
 * (Q7 case 5 — Provider 부재 시 data prop 으로 동작).
 */

import { createContext, useContext } from 'react';

import type { CoreUIDataContextValue } from './types';

export const CoreUIDataContext = createContext<CoreUIDataContextValue | null>(null);

/**
 * Provider context value 조회. Provider 부재 시 `null` 반환.
 *
 * 호스트가 직접 호출할 일은 없음 — 위젯 내부에서만 사용.
 */
export const useCoreUIDataContext = (): CoreUIDataContextValue | null => useContext(CoreUIDataContext);
